import http from "infra/http";
import { useQuery } from "react-query";
import { RateioFechamentoPorMesItem } from "../typings";
import { PaginateResult } from 'core/resources/types/shared';

function useGetFechamentosRateiosPorMes() {
  return useQuery([`/v1/rateio/fechamentos-por-mes`], async () => {
    const { data } = await http.get<PaginateResult<RateioFechamentoPorMesItem>>(`/v1/rateio/fechamentos-por-mes`);

    return data;
  });
}

export default useGetFechamentosRateiosPorMes;
